/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatorNotesDto } from '../models/CreatorNotesDto';
import type { CreatorNotesRequestDto } from '../models/CreatorNotesRequestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CreatorNotesApiService {
    /**
     * Get Creator notes
     * @returns CreatorNotesDto Creator notes
     * @throws ApiError
     */
    public static getCreatorNotes({
        creatorId,
    }: {
        creatorId: number,
    }): CancelablePromise<CreatorNotesDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/creator-notes/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            errors: {
                403: `User don't have admin permissions`,
            },
        });
    }
    /**
     * Update Creator notes
     * @returns void
     * @throws ApiError
     */
    public static updateCreatorNotes({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: CreatorNotesRequestDto,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/creator-notes/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `User don't have admin permissions`,
            },
        });
    }
}
